const createLayerLoaderController = function ({
  $ = window.jQuery,
  $body = $('body'),
  windowRef = window,
  fnT = function (key) { return String(key || '') },
  fnGetDb = function () { return {} },
  store = {},
  areaSwal = window.Swal,
  fnLayerNotams = function () {},
  fnLayerAirSpaces = function () {},
  fnLayerAirPorts = function () {},
  fnLayerNature = function () {},
  fnLayerUser = function () {},
  fnVersions = function () {},
  fnLayerFilterAll = function () {},
  fnGetMap = function () { return null },
  fnResetLayersOnMap = function () {},
} = {}) {

  let timeCollectLayers = null
  let ajaxTimer = null
  let ajaxCounter = 0

  const collectLayers = function () {
    const db = fnGetDb() || {}
    if (!db.settings || typeof db.settings !== 'object') db.settings = {}
    db.settings.overlayActive = []
    $('.leaflet-right').find('.leaflet-control-layers-selector').each(function () {
      const $input = $(this)
      if ($input.prop('checked')) {
        const overlay = $input.next('span').find('[data-overlay]').data('overlay')
        db.settings.overlayActive.push(overlay.id * 1)
      }
    })
    if (store && typeof store.setAll === 'function') {
      void store.setAll(db)
    }
    fnLayerFilterAll()
  }

  const bindLayerControlEvents = function () {
    if (!$body || typeof $body.data !== 'function') return
    if ($body.data('portalLayerLoaderBound')) return
    $body.data('portalLayerLoaderBound', true)

    $body.on('input.portalLayerLoader', '.leaflet-control-layers-selector', function () {
      clearTimeout(timeCollectLayers)
      timeCollectLayers = setTimeout(function () {
        collectLayers()
      }, 300)
    })

    $body.on('input.portalLayerLoader', '.leaflet-control-layers-base input', function () {
      const db = fnGetDb() || {}
      if (!db.settings || typeof db.settings !== 'object') db.settings = {}
      db.settings.baseMap = $(this).parent().find('span').text().trim()
      if (store && typeof store.setAll === 'function') {
        void store.setAll(db)
      }
    })
  }

  const getLayers = function (_filter) {
    const map = fnGetMap()
    const db = fnGetDb() || {}
    if (!db.settings || typeof db.settings !== 'object') db.settings = {}

    fnResetLayersOnMap()
    $.each(windowRef.airSpaceTypes, function (_id, ast) {
      ast.overlay.eachLayer(function (layer) {
        if (!!layer.toGeoJSON) {
          ast.overlay.removeLayer(layer)
          map.removeLayer(layer)
        }
      })
    })
    if (!Array.isArray(db.settings.overlayActive)) db.settings.overlayActive = []
    if (db.settings.overlayActive.length === 0) {
      const oac = Object.keys(windowRef.airSpaceTypes)
      $.each(oac, function (key, airspaceClassId) {
        oac[key] = airspaceClassId * 1
      })
      db.settings.overlayActive = oac
    }
    ajaxCounter = 0
    if (ajaxTimer) clearInterval(ajaxTimer)
    ajaxTimer = setInterval(function () {
      ajaxCounter += 1
      if (ajaxCounter > 2) {
        areaSwal.fire({
          width: 500,
          title: (`
            ${fnT('layers.loading_title')}
            <small style="font-size: 6px; --fa-animation-duration: 2s;">
              <i class="fa-bounce fa-solid fa-circle me-1"></i>
              <i class="fa-bounce fa-solid fa-circle me-1" style="--fa-animation-delay: 100ms"></i>
              <i class="fa-bounce fa-solid fa-circle" style="--fa-animation-delay: 300ms"></i>
            </small>
            `).replace(/\n/g, ''),
          html: '<span class="d-inline-block mt-5 mb-5 fa-beat-fade overflow-hidden"><i class="text-body-tertiary fa-regular fa-compass fa-spin" style="font-size: 200px; --fa-animation-duration: 15s;"></i></span>',
          showConfirmButton: false
        })
        clearInterval(ajaxTimer)
        ajaxTimer = null
      }
    }, 1000)
    $.ajax({
      url: '/get-layers',
      data: {},
      success: function (res) {
        console.log(res)
        fnLayerNotams(res)
        fnLayerAirSpaces(res)
        fnLayerAirPorts(res)
        fnLayerNature(res)
        fnLayerUser(res)
        fnVersions(res)
        if (ajaxTimer) {
          clearInterval(ajaxTimer)
          ajaxTimer = null
        }
        areaSwal.close()
        fnLayerFilterAll()
      },
      error: function (xhr) {
        let errorMessage = fnT('auth.permission_missing')
        const status = Number(xhr && xhr.status ? xhr.status : 0)
        if (status === 401) {
          errorMessage = fnT('auth.please_login')
        }
        const responseError = String(xhr && xhr.responseJSON && xhr.responseJSON.error ? xhr.responseJSON.error : '').trim()
        if (responseError) {
          errorMessage = responseError
        }
        console.error('Layer load request failed', {
          status: status,
          responseError: responseError
        })
        areaSwal.close()
        areaSwal.fire(errorMessage)
      },
      complete: function () {
        if (ajaxTimer) {
          clearInterval(ajaxTimer)
          ajaxTimer = null
        }
        areaSwal.close()
      }
    })
  }

  return {
    collectLayers: collectLayers,
    bindLayerControlEvents: bindLayerControlEvents,
    getLayers: getLayers
  }
}

export {
  createLayerLoaderController
}
